/**
 * renderTemplatePreview — 1:1 Frontend-Reimplementierung der Backend-Funktion renderTemplate,
 * angepasst fuer die Vorschau-Nutzung: FEHLENDE Variablen bleiben als {{...}} erhalten
 * (nicht leer ersetzt). So sieht der User im Vorschau-Panel direkt, welche Platzhalter
 * noch nicht gefuellt sind.
 *
 * Regex-Pattern: /\{\{\s*(\w+)\s*\}\}/g — toleriert optionale Leerzeichen innerhalb der Klammern.
 *
 * Pure function — kein Side-Effect. Vitest-tauglich.
 */

export interface TemplateLike {
  subject: string;
  bodyText: string;
  bodyHtml: string | null;
}

/** Regex: {{ varName }} oder {{varName}} — optionale Leerzeichen werden toleriert. */
const VAR_RE = /\{\{\s*(\w+)\s*\}\}/g;

function substitute(text: string | null, vars: Record<string, string>): string | null {
  if (text === null) return null;
  return text.replace(VAR_RE, (match, name: string) => {
    return Object.prototype.hasOwnProperty.call(vars, name) ? vars[name] : match;
  });
}

/**
 * Rendert ein Template mit Beispiel-Variablen.
 * Fehlende Variablen bleiben als {{variablenname}} erhalten.
 *
 * @param template - Objekt mit subject, bodyText, bodyHtml
 * @param vars - Variable-Substitutionen (z.B. { verein_name: 'FC Beispiel' })
 * @returns Gerendertes Objekt mit subject, bodyText, bodyHtml
 */
export function renderTemplatePreview(
  template: TemplateLike,
  vars: Record<string, string>,
): { subject: string; bodyText: string; bodyHtml: string | null } {
  return {
    subject: substitute(template.subject, vars) ?? '',
    bodyText: substitute(template.bodyText, vars) ?? '',
    bodyHtml: substitute(template.bodyHtml, vars),
  };
}
